type ChunkResult<T> = { data: T[] | null; error: { message: string } | null };

export const IN_CHUNK_SIZE = 40;
const PARALLEL_REQUESTS = 6;

/** Esegue una lettura con `.in(...)` a blocchi: un elenco lungo in un solo indirizzo viene rifiutato dal server (400/502). */
export async function fetchInChunks<T>(
  ids: string[],
  run: (chunk: string[]) => PromiseLike<ChunkResult<T>>,
  size: number = IN_CHUNK_SIZE,
): Promise<T[]> {
  const chunks: string[][] = [];
  for (let i = 0; i < ids.length; i += size) chunks.push(ids.slice(i, i + size));
  const results: T[][] = new Array(chunks.length);
  let next = 0;
  const worker = async () => {
    while (next < chunks.length) {
      const index = next++;
      const { data, error } = await run(chunks[index]);
      if (error) throw new Error(error.message);
      results[index] = data ?? [];
    }
  };
  await Promise.all(Array.from({ length: Math.min(PARALLEL_REQUESTS, chunks.length) }, worker));
  return results.flat();
}
